import { render, staticRenderFns } from "./MobageTips.vue?vue&type=template&id=49d30446&scoped=true&"
import script from "./MobageTips.vue?vue&type=script&lang=js&"
export * from "./MobageTips.vue?vue&type=script&lang=js&"
import style0 from "./MobageTips.vue?vue&type=style&index=0&id=49d30446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d30446",
  null
  
)

component.options.__file = "MobageTips.vue"
export default component.exports